<template>
  <component
    :is="rendered.component"
    v-if="rendered"
    :key="rendered.id"
    v-bind="boundProps"
    :is-visible="isVisible"
    @cancel="resolve('onCancel')"
    @close="resolve('onClose')"
    @confirm="resolve('onConfirm')"
  >
    <template v-for="(slotFn, name) in boundSlots" #[name]="slotProps">
      <component :is="slotFn" v-if="slotFn" :key="name" v-bind="slotProps" />
    </template>
  </component>
</template>

<script lang="ts" setup>
import type { ResolvedModal } from '~/composables/modalIsolated'

const { activeModal, cancelModal, closeModal, confirmModal, resolvedModal } = useModal()
const route = useRoute()

const resolvers = { onCancel: cancelModal, onClose: closeModal, onConfirm: confirmModal }

watch(
  () => route.path,
  (path) => {
    const modal = activeModal.value
    if (!modal || modal.persistent) return
    if (modal.routePath === path) return

    closeModal(modal.id)
  },
)

const rendered = ref<ResolvedModal>()
const isVisible = ref(false)

watchImmediate(resolvedModal, (modal) => {
  rendered.value = modal
  isVisible.value = Boolean(modal)
})

const boundProps = computed(() => resolvedModal.value?.props ?? {})

const boundSlots = computed(() => resolvedModal.value?.slots ?? {})

const resolve = (method: keyof typeof resolvers) => {
  if (rendered.value) resolvers[method](rendered.value.id)
}
</script>
